import { tailwindTheme as e } from "./tailwind/index.js";
import { antdTheme as o } from "./antd/index.js";
import { useTheme as s } from "./hooks/index.js";
const { token: t, components: m } = o, p = {
  ...e,
  token: t,
  components: m
};
export {
  p as theme,
  s as useTheme
};
